import { render, staticRenderFns } from "./CategoriesSliderComponent.vue?vue&type=template&id=5759bedd&scoped=true&"
import script from "./CategoriesSliderComponent.vue?vue&type=script&lang=ts&"
export * from "./CategoriesSliderComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CategoriesSliderComponent.vue?vue&type=style&index=0&id=5759bedd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5759bedd",
  null
  
)

export default component.exports